<script>
import formatDate from '@utils/format-date'
import formatTime from '@utils/format-time'
import tConvert from '@utils/format-hour'
import { emailMethod } from '@state/helpers'
import moment from 'moment'
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    display: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'xl',
    },
  },
  data() {
    return {
      show: true,
      isSuccess: false,
      successMessage: '',
    }
  },
  methods: {
    ...emailMethod,
    hide() {
      this.show = false
    },
    formatDates(date) {
      return formatDate(date)
    },
    getTime(time) {
      return tConvert(formatTime(time))
    },
    getEventTime(time) {
      return tConvert(formatTime(moment(time).format('HH:mm')))
    },
    sendemail(data) {
      return this.sendEmail({
        userData: data,
      }).then((res) => {
        this.isSuccess = true
        this.successMessage = res.msg
      })
    },
    resetModal() {
      this.isSuccess = false
      this.successMessage = ''
    },
  },
}
</script>
<template>
  <div class="alert">
    <b-modal
      id="my-modal"
      v-model="show"
      scrollable
      :size="size"
      @hidden="resetModal"
    >
      <template v-slot:modal-title>
        <h4>Details</h4>
      </template>
      <table class="table table-bordered table-inverse table-responsive-lg">
        <tbody>
          <tr v-for="(item, index) in display" :key="index">
            <td
              v-if="
                data[item.key] ||
                  item.label === 'Blocked' ||
                  item.label === 'Locked' ||
                  item.label === 'Login Status' ||
                  item.label === 'Registration Status' ||
                  item.label === 'Added On' ||
                  item.label === 'Email Sent'
              "
            >
              <strong>{{ item.label }}</strong>
            </td>
            <td v-if="item.label === 'Name'">
              <div>{{ data[item.key] }}</div>
            </td>
            <td v-else-if="item.label === 'Course Assigned'">
              <div
                v-for="(item1, index1) in data[item.key]"
                :key="`list${index1}`"
              >
                <p>{{ item1.name }}</p>
              </div>
            </td>
            <td v-else-if="item.label === 'Assigned Students'">
              <div
                v-for="(item1, index1) in data[item.key]"
                :key="`list${index1}`"
              >
                <p>{{ item1.name }}</p>
              </div>
            </td>
            <td v-else-if="item.key === 'teacher_id'">
              <div
                v-for="(item1, index1) in data[item.key]"
                :key="`list${index1}`"
              >
                <p>{{ item1.name }}</p>
              </div>
            </td>
            <td v-else-if="item.label === 'Assigned Batches'">
              <div
                v-for="(item1, index1) in data[item.key]"
                :key="`list${index1}`"
              >
                <p v-if="item1.name !== undefined">{{ item1.name }}</p>
                <p v-else>{{ item1 }}</p>
              </div>
            </td>
            <td
              v-else-if="
                item.label === 'Document(s)' &&
                  data[item.key] !== undefined &&
                  data[item.key].length !== '0'
              "
            >
              <div
                v-for="(item1, index1) in data[item.key]"
                :key="`list${index1}`"
              >
                <p>{{ item1 }}</p>
              </div>
            </td>
            <td
              v-else-if="
                item.label === 'Video(s)' &&
                  data[item.key] !== undefined &&
                  data[item.key].length !== '0'
              "
            >
              <div
                v-for="(item1, index1) in data[item.key]"
                :key="`list${index1}`"
              >
                <p>{{ item1.title }}</p>
              </div>
            </td>
            <td v-else-if="item.label === 'Assigned By'">
              {{ data[item.key].email }}
            </td>
            <td v-else-if="item.label === 'Added By'">
              {{ data[item.key].email }}
            </td>
            <td
              v-else-if="
                item.label === 'Submission Deadline' &&
                  data[item.key] !== undefined
              "
            >
              {{ formatDates(data[item.key]) }}
            </td>
            <td v-else-if="item.label === 'Category'">
              <div>{{ data['category'].name }}</div>
            </td>
            <td v-else-if="item.key === 'categoryData'">
              <div v-if="data.categoryData.length >= 1">{{
                data.categoryData[0].name
              }}</div>
              <div v-else>-</div>
            </td>
            <td v-else-if="item.key === 'department'">
              <div v-if="data.departmentData.length !== 0">{{
                data.departmentData[0].name
              }}</div>
              <div v-else>-</div>
            </td>
            <td v-else-if="item.key === 'college_id'">
              <div>{{ data.collegeData[0].name }}</div>
            </td>
            <td v-else-if="item.colType === 'html'">
              <div v-html="data[item.key]"></div>
            </td>
            <td v-else-if="item.colType === 'list'">
              <ul style="margin-left:10px;">
                <li
                  v-for="(item1, index1) in data[item.key]"
                  :key="`list${index1}`"
                  >{{ item1 }}</li
                >
              </ul>
            </td>
            <td v-else-if="item.colType === 'list'">
              <ul>
                <li
                  v-for="(item1, index1) in data[item.key]"
                  :key="`list${index1}`"
                  >{{ item1 }}</li
                >
              </ul>
            </td>
            <td v-else-if="item.colType === 'content'">
              <ul
                v-for="(item1, index1) in data[item.key]"
                :key="`list${index1}`"
                style="margin-left: 10px"
              >
                <li><b>Title: </b> {{ item1.title ? item1.title : 'N/A' }}</li>
                <li
                  ><b>Video Id: </b>
                  {{ item1.videoId ? item1.videoId : 'N/A' }}</li
                >
                <li
                  ><b>Pdf Link: </b>
                  {{ item1.pdf_link ? item1.pdf_link : 'N/A' }}</li
                >
                <li
                  ><b>Note Link: </b>
                  {{ item1.note_link ? item1.note_link : 'N/A' }}</li
                >
                <li
                  ><b>Exercise Link: </b>
                  {{ item1.exercise_link ? item1.exercise_link : 'N/A' }}</li
                >
              </ul>
            </td>
            <td v-else-if="item.label === 'Registration Status'">
              <b-badge v-if="data[item.key] === true" variant="success"
                >Done</b-badge
              >
              <b-badge v-else variant="danger">Pending</b-badge>
            </td>
            <td v-else-if="item.key === 'emailStatus'">
              <b-badge v-if="data[item.key] === true" variant="success"
                >Yes</b-badge
              ><p v-else>
                <b-badge variant="danger">No</b-badge>
                <b-button class="mailbutton" @click="sendemail(data)"
                  >Send Mail</b-button
                >
                <br /><br /><b-alert
                  v-model="isSuccess"
                  variant="success"
                  v-html="successMessage"
                ></b-alert>
              </p>
            </td>
            <td v-else-if="item.key === 'loginStatus'">
              <b-badge v-if="data[item.key] === true" variant="success"
                >Active</b-badge
              >
              <b-badge v-else variant="danger">Inactive</b-badge>
            </td>
            <td v-else-if="item.label === 'Blocked'">
              <b-badge v-if="data[item.key] === 'spam'" variant="danger"
                >Yes</b-badge
              >
              <b-badge v-else variant="success">No</b-badge>
            </td>
            <td v-else-if="item.label === 'Locked'">
              <b-badge
                v-if="new Date(data[item.key]) > new Date()"
                variant="danger"
                >Yes</b-badge
              >
              <b-badge v-else variant="success">No</b-badge>
            </td>
            <td v-else-if="item.colType === 'badge'">
              <b-badge
                :variant="
                  data[item.key] === 'active' || data[item.key] === true
                    ? 'success'
                    : 'danger'
                "
                >{{ data[item.key] }}</b-badge
              >
            </td>
            <td
              v-else-if="
                item.colType === 'date' && item.label !== 'Submission Deadline'
              "
            >
              {{ formatDates(data[item.key]) }}
            </td>

            <td
              v-else-if="
                item.colType === 'time' || item.colType === 'start_time'
              "
            >
              {{ getTime(data[item.key]) }}
            </td>
            <td v-else-if="item.colType === 'eventtime'">
              {{ getEventTime(data[item.key]) }}
            </td>
            <td v-else-if="data[item.key]">{{ data[item.key] }}</td>
          </tr>
        </tbody>
      </table>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="hide"
            >Close</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<style>
.modal-backdrop {
  opacity: 0.5;
}
.mailbutton {
  margin-left: 15px;
}
</style>
